export interface PausableByteStream {
  on(event: "data", callback: (chunk: Uint8Array) => void): this;
  on(event: "error", callback: (error: Error) => void): this;
  on(event: "end", callback: () => void): this;
  pause(): this;
  resume(): this;
}

export function readBoundedUtf8Stream(
  stream: PausableByteStream,
  maximumBytes: number,
  tooLargeError: () => Error,
): Promise<string> {
  const decoder = new TextDecoder();
  return new Promise((resolve, reject) => {
    let byteCount = 0;
    let value = "";
    let settled = false;

    const fail = (error: Error) => {
      if (settled) return;
      settled = true;
      value = "";
      stream.pause();
      reject(error);
    };

    stream
      .on("data", (chunk) => {
        if (settled) return;
        byteCount += chunk.byteLength;
        if (byteCount > maximumBytes) {
          fail(tooLargeError());
          return;
        }
        value += decoder.decode(chunk, { stream: true });
      })
      .on("error", fail)
      .on("end", () => {
        if (settled) return;
        settled = true;
        resolve(value + decoder.decode());
      })
      .resume();
  });
}
